<template>
  <vs-card class="overflow-hidden">
    <div class="flex justify-between" slot="header">
      <h2>Bar Chart</h2>
      <!-- {{checkGeneratePermission()}} -->
      <vx-tooltip title="Generate Graph" position="bottom">
        <vs-button
        v-if="checkGeneratePermission()"
          type="border"
          icon="keyboard_arrow_down"
          @click="openGenerate = !openGenerate"
        ></vs-button>
      </vx-tooltip>
    </div>

    <!-- {{platform_modules}} -->
    <!-- {{ dateRange }} -->
    <div class="form_field_holder" :class="{ show: openGenerate }">
    

      <div class="flex flex-wrap items-center">
          
        <div class="lg:w-1/4 md:w-1/2 w-full p-2">
          <label>Module List</label>

          <v-select
            class="w-full"
            :options="get_platform_modules_item_data"
            label="module_name"
            :reduce="(item) => item.platform_modules_id"
            v-model="platform_module_id"
          ></v-select>
          <!-- {{ platform_module_id }} -->
        </div>
          <div class="lg:w-1/4 md:w-1/2 w-full p-2">
          <label>Select Date</label>

          <date-range-picker
        ref="picker"
        class="w-full"
        :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
        :showWeekNumbers="true"
        :showDropdowns="true"
        :autoApply="true"
        :ranges="customDateRanges()"
        v-model="dateRange"
      >
        <template v-slot:input="picker" style="min-width: 350px">
          {{ picker.startDate | date }} - {{ picker.endDate | date }}
        </template>
      </date-range-picker>
          <!-- {{ platform_module_id }} -->
        </div>
       
        <div class="lg:w-1/4 md:w-1/2 w-full p-2">
          <label>X Axis</label>
          <v-select
            class="w-full"
            :options="xAxisFieldOption"
            v-model="xAxisFieldId"
            :reduce="(item) => item.id"
            label="name"
          ></v-select>
        </div>
        <div class="lg:w-1/4 md:w-1/2 w-full p-2">
          <label>Y Axis</label>
          <!-- {{ yAxisFieldOption }} -->
          <v-select
            class="w-full"
            :options="yAxisFieldOption"
            v-model="yAxisFieldId"
            :reduce="(item) => item.id"
            label="name"
          ></v-select>
        </div>
      </div>
      <div class="p-2 sm:flex justify-between">
        <vs-button class="my-1" :disabled="!allFieldsSelected" @click="generateGraphApi"
          >Generate Graph</vs-button
        >
        <vs-button class="my-1" :disabled="!saveGraphChecking" @click="openSavePopUp()"
        v-if="checkSaveModulePermission()"
          >Save this Graph</vs-button
        >
      </div>
    </div>
    <div id="chart">
      <apexchart
        type="bar"
        height="350"
        :options="chartOptions"
        :series="series"
        ref="apexChart"
      ></apexchart>
    </div>
    <div v-if="saveGraphPopUp">
      <vs-popup
        class="holamundo"
        title="Graph"
        :active.sync="saveGraphPopUp"
      >
        <SaveGraphComponent
          :graph_type="GRAPH_TYPE"
          :x_axis="xAxisFieldId"
          :y_axis="yAxisFieldId"
          :platform_module_id="platform_module_id"
          :dateRange="dateRange"
          @closeSavePopUp="closeSavePopUp"
        >
        </SaveGraphComponent>
      </vs-popup>
    </div>
  </vs-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { BarLineAreaMixins } from '../mixins/BarLineAreaMixins'
import SaveGraphComponent from './SaveGraphComponent.vue'
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually (in case you want to override it)
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

import vSelect from 'vue-select'
export default {
  components: {
    vSelect,
    apexchart: VueApexCharts,
    SaveGraphComponent,
    DateRangePicker
  },
  mixins: [BarLineAreaMixins],
  props: {
    platform_modules: {
      type: Array,
      required: true,
      default: () => []
    },
    SelectedBarGraphId:{
    }
  },
  watch:{
    SelectedBarGraphId () {
      
      if (this.SelectedBarGraphId) {
        this.getGenratedSaveData(this.SelectedBarGraphId)
        this.generateGraph = false


      }
    }
  },
  data () {
    return {
      saveGraphPopUp:false,
      dateRange: {},
      GRAPH_TYPE: 'bar',
      openGenerate: false,
      platform_module_id: null,
      xAxisFieldOption: [],
      yAxisFieldOption: [],
      xAxisFieldId: null,
      yAxisFieldId: null,
      platform_field_x: null,
      platform_field_y: null,
      options: [],
      series: [
        {
          data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380]
        }
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 500
        },
        colors:[JSON.parse(localStorage.getItem('localization')).secondary_color],

        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: [
            'South Korea',
            'Canada',
            'United Kingdom',
            'Netherlands',
            'Italy',
            'France',
            'Japan',
            'United States',
            'China',
            'Germany'
          ]
        }
      }
    }
  },
  created () {
    
  }
}
</script>
